import { asyncConnect } from 'redux-connect';
import { isRouteLoader } from '../routes/utils/defineLoader';

function runLoader(loader, { match, location, helpers }) {
  return loader.load({
    params: match?.params ?? {},
    location: { pathname: location?.pathname ?? '', search: location?.search ?? '' },
    services: helpers.services,
  });
}

/**
 * Runs a route's dependencies on the server and before client navigation. A dependency is either a
 * loader from `defineLoader`, or a function of the component props that returns an action to
 * dispatch.
 */
export default function connectAsync(dependencies, ...args) {
  const arrayOfPromises = dependencies.map((dependency) => ({
    promise: async (componentProps) => {
      if (isRouteLoader(dependency)) {
        return runLoader(dependency, componentProps);
      }

      const { store } = componentProps;
      const maybeActionResponse = dependency(componentProps);

      return maybeActionResponse ? store.dispatch(maybeActionResponse) : maybeActionResponse;
    },
  }));

  return asyncConnect(arrayOfPromises, ...args);
}
